const gsap = window.gsap;

if (gsap !== undefined) {
  gsap.utils.toArray(".section_split_text").forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      start: "top bottom",
      end: "bottom top",
      scrub: true,
      onUpdate: (self) => {
        const y = (self.progress - 0.5) * 100;
        gsap.set(el, { "--y": y + "px" });
      },
    });
  });

  gsap.from(".section_split_text .container", {
    autoAlpha: 0,
    opacity: 0,
    duration: 2,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".section_split_text",
      start: "top 50%",
    },
  });
}
